export default {
  colon: ':',
  export: 'Export',
  delete: 'Delete',
  view: 'View',
  send: 'Send',
  sending: 'Sending',
  search: 'Search',
  find: 'Search',
  save: 'Save',
  saved: 'Saved',
  cancel: 'Cancel',
  close: 'Close',
  dismiss: 'Dismiss',
  name: 'Name',
  value: 'Value',
  description: 'Description',
  updatedIn: 'Last modified:',
  defaultFolder: 'Root Folder',
  codeGenerate: 'Generate Code',
  responsible: 'Maintainer',
  format: 'Format',
  moreHelp: 'Help',
  copyToClipboard: 'Copy to clipboard',
  noContent: 'No Content',
  enumeratedValue: 'Enums',
  'message.requestException': 'Request exception',
  'message.requestError': 'Request exception',
  'message.exportSuccess': 'Export Successful.',
  'message.networkFailure': 'Network Error, please check the network, or try again later',
  'message.serverFailure': 'Server Error, please try again later',
  'button.text.reload': 'Reload',
  'message.loadError.checkNetwork': 'Load error, please check whether the network is down',
  'message.scriptError.checkNetworkOrContactStaff':
    "An abnormal error occurred, please try 'Reload' or 'get Support' to help you solve it!",
  more: 'More',
  download: 'Download',
  downloadFileAndUnitSize: 'Download({unitSize})',
  viewAsText: 'View as text',
  copyContent: 'Copy Content',
  wrap: 'Wrap',
  request: 'Request',
  response: 'Response',
  'request.example.title.right': 'Request',
  'request.example.title.center': ' Request Example',
  'response.example.title.right': 'Response',
  'response.example.title.center': ' Response Example',
  redirect: 'Redirect',
  console: 'Console',
  header: 'Headers',
  cookie: 'Cookies',
  selectCharset: 'Select Charset',
  isCopied: 'Copied',
  failToCopied: 'Fail to copy, please manually record the following content',
  'runner.tryItOut': 'Try it out',
  'runner.selectCase': 'Select Case',
  tryItOut: 'Try it',
  runInApp: 'Run in {appName}',
  clone: 'Clone',
  'customDomain.cname.alibaba': 'The domain is ICP Alibaba Cloud',
  'customDomain.cname.otherCloud': 'The domain is ICP Tencent Cloud',
  'customDomain.cname.HK': 'Hong Kong Server, a bit slower',
  graphqlGetTips:
    "When making an HTTP GET request, the GraphQL query should be defined in the 'query' field of the Params.",
  onlineShareHasBeenCopyToTeam:
    'Cloned API documentation <strong>【{onlineShareName}】</strong>  to team <strong>【{teamName}】</strong>',
  'onlineShare.export': 'Export Data',
  'onlineShare.export.dataType': 'Data Format',
  'exportData.export.openapi.version': 'OpenAPI Spec Version',
  'exportData.export.openapi.version.31': 'OpenAPI 3.1',
  'exportData.export.openapi.version.30': 'OpenAPI 3.0',
  'exportData.export.openapi.version.20': 'Swagger 2.0',
  'exportData.export.openapi.includeExtension':
    'Including {appName} Extension OpenAPI Fields (x-{appNameLower}-***)',
  'exportData.export.openapi.includeExtension.no': 'No',
  'exportData.export.openapi.includeExtension.yes': 'Yes',
  'exportData.export.openapi.tags': 'Export folder as Tags field',
  'exportData.export.openapi.tags.yes': 'Yes',
  'exportData.export.openapi.tags.no': 'No',
  'onlineShare.clone': 'Clone to My {appName}',
  'onlineShare.notExisted': 'This documentation does not exist or has been deleted.',
  'onlineShare.noAccess': 'You do not have permission to access this documentation',
  'onlineShare.expired.subTitle': 'Please contact the documentation sharer',
  'apidoc.unPublish': 'This documentation is not yet published',
  'apidoc.unPublish.subTitle':
    'Please contact the documentation publisher to publish the documentation before accessing the current URL.',
  'onlineShare.needPassword': 'This documentation requires a password to access',
  'onlineShare.sendCodeSuccess':
    'If your email is on the allow list, you will receive the verification code soon.',
  'exportData.appDocumentation.json': 'apiDocumentation.{appNameLower}.json',
  'onlineShare.resource.notExisted.title': '404',
  'onlineShare.resource.notExisted.subTitle': `Page not found`,
  'onlineShare.resource.notExisted.reload': 'Reload',
  backToHome: 'Back to home',
  'email.auth.tip': 'This documentation requires an email verification code to access',
  'customDomain.error.tip': 'Invalid CNAME Configuration. Please check the rules below.',
  'customDomain.error.tip2': 'Invalid CNAME Configuration.',
  previous: 'Previous',
  next: 'Next',
  'message.noPrivilege': 'Insufficient permissions',
  'onlineShare.expired': 'This documentation access period has expired',
  'onlineShare.notShared': 'This documentation is not yet shared',

  'docsSite.enableVibeCodingViaMCP.suffix': 'API Specification',
  'docsSite.enableVibeCodingViaMCP': 'Vibe Coding (via MCP)',
  'docsSite.enableVibeCodingViaMCP.modal.title': 'Vibe Coding (via MCP)',
  'docsSite.enableVibeCodingViaMCP.modal.description':
    '## 🚀 Configuration Guide\n\n### **Prerequisites**\n\n- **Node.js** (version 18 or higher, preferably the latest LTS version).\n- An IDE that supports MCP, such as:\n  - **Cursor**\n  - **VS Code + Cline plugin**\n\n### Configure the IDE\n\n- Copy the following JSON configuration code to add to the MCP configuration file in your IDE:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "npx",\n      "args": [\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\nIf you\'re on **Windows** and the configuration file above isn\'t working, try using the configuration file below instead:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "cmd",\n      "args": [\n        "/c",\n        "npx",\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n## 🎯 How {appName} MCP Server Works?\n\nOnce the {appName} MCP Server is set up, it automatically reads and caches all API documentation data on your local machine. The AI can then retrieve and utilize this data seamlessly.\n\nSimply instruct the AI on what you’d like to achieve with the API documentation. Here are some examples:\n\n1. **Generate Code**: "Use MCP to fetch the API documentation and generate Java records for the \'Product\' schema and related schemas".\n2. **Update DTOs**: "Based on the API documentation, add the new fields to the \'Product\' DTO".\n3. **Add Comments**: "Add comments for each field in the \'Product\' class based on the API documentation".\n4. **Create MVC Code**: "Generate all the MVC code related to the endpoint \'/users\' according to the API documentation".',
};
